import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import "./App.css";
import "./pages/css/styles.css";
import Nav from "./pages/Nav";
import Footer from "./pages/Footer";
import Home from "./pages/Home";
import Advertisers from "./pages/Advertiser";
import Privacypolicy from "./pages/Privacypolicy";
import Programmatic from "./pages/Programmatic";
import Publishers from "./pages/Publisher";
import Terms_condition from "./pages/Terms_condition";
import Cookies from "./pages/Cookies";
import Pagenotfound from "./pages/Pagenotfound";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

let data = {
  Homepage: {
    title: "AiPlex Ads | Affiliate Network Channel",
    description:
      "AiPlex Ads,  is a Ad Network, understands Publishers and Advertisers extremely well. We cultivate mutually-beneficial partnerships between Advertisers & Publishers",
  },
  advertisers: {
    title: "Advertisers | AiPlex Ads",
    description:
      "Drive more transactions and reward world-class publishers for successfully promoting your products/services.",
  },
  publishers: {
    title: "Publishers | AiPlex Ads",
    description:
      "AiPlex connects  leading brands with publishers all over the world with a reliable, transparent and trusted tracking and commission payment mechanism.",
  },
  programmatic: {
    title: "Programmatic Solutions | AiPlex",
    description:
      "Aiplex provides programmatic ad solutions to digital advertisers, publishers, and ad agencies across the globe. ",
  },
};

function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}>
    <div>
      <Router>
        <Nav />

        <Routes>
          <Route path="/" element={<Home value={data["Homepage"]} />} />
          <Route path="/about" element={<Home value={data["Homepage"]} />} />
          <Route
            path="/advertisers"
            element={<Advertisers value={data["advertisers"]} />}
          />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route
            path="/programmatic"
            element={<Programmatic value={data["programmatic"]} />}
          />
          <Route
            path="/publishers"
            element={<Publishers value={data["publishers"]} />}
          />
          <Route path="/terms-condition" element={<Terms_condition />} />
          <Route path="/cookies" element={<Cookies />} />
          {/* 404 page */}
          <Route path="*" element={<Pagenotfound />} />
        </Routes>

        <Footer />
      </Router>
    </div>
    </GoogleReCaptchaProvider>
  );
}

export default App;
